import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

type UserState = {
  email: string;
  id: string;
  name: string;
  phoneNumber: string;
};

type UserAction = {
  setUserInfo: (userState: UserState) => void;
};

const INIT_USER_INFO: UserState = {
  email: '',
  id: '',
  name: '',
  phoneNumber: ''
};

export const useUserStore = createWithEqualityFn<UserState & UserAction>()(
  (set) => ({
    ...INIT_USER_INFO,
    setUserInfo: ({ email, id, name, phoneNumber }) => set({ email, id, name, phoneNumber })
  }),
  shallow
);
